export default {"src":"/_next/static/media/CredlixLogo.7ed30939.svg","height":33,"width":114};